import { AlertTriangle, Inbox, Loader2 } from "lucide-react";
import type { ReactNode } from "react";
import { errorMessage } from "@/lib/api/client";
import { illustrationUrl, type Illustration } from "@/lib/assets/illustrations";
import { cn } from "@/lib/cn";
import { Button } from "./button";

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn("ico animate-spin", className)} aria-hidden="true" />;
}

export function Loading({ label = "加载中…", className }: { label?: string; className?: string }) {
  return (
    <div className={cn("empty", className)} role="status">
      <Spinner />
      <span className="body-sm">{label}</span>
    </div>
  );
}

export function ErrorState({ error, onRetry, className }: { error: unknown; onRetry?: () => void; className?: string }) {
  return (
    <div className={cn("empty", className)} role="alert">
      <AlertTriangle className="ico-20 text-danger" aria-hidden="true" />
      <span className="body-sm">{errorMessage(error, "加载失败")}</span>
      {onRetry ? (
        <Button size="sm" variant="outline" onClick={onRetry}>
          重试
        </Button>
      ) : null}
    </div>
  );
}

/** art：插画（代替图标）；artSize sm 用于侧栏、对话框等窄处。 */
export function Empty({ title, children, icon, art, artSize, className }: {
  title: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  art?: Illustration;
  artSize?: "sm" | "md";
  className?: string;
}) {
  return (
    <div className={cn("empty", art && "empty-has-art", className)}>
      {art ? (
        <img src={illustrationUrl(art)} alt="" aria-hidden="true" draggable={false} decoding="async" className={cn("empty-art", artSize === "sm" && "empty-art-sm")} />
      ) : (
        (icon ?? <Inbox className="ico-20" aria-hidden="true" />)
      )}
      <span className="body-medium" style={{ color: "var(--foreground)" }}>
        {title}
      </span>
      {children}
    </div>
  );
}

export function Skeleton({ className, style }: { className?: string; style?: React.CSSProperties }) {
  return <div className={cn("skeleton", className)} style={style} aria-hidden="true" />;
}

export function ErrLine({ children }: { children: ReactNode }) {
  return (
    <div className="err-line" role="alert">
      {children}
    </div>
  );
}
